module.exports = __webpack_public_path__ + "static/letter-2767b4233a8ac0b6d61993fd0aff557c.svg";